module.exports = __webpack_public_path__ + "static/media/header-plan.0ad148fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/header-plan.svg
// module id = 528
// module chunks = 0